import cn from "classnames";
import React from "react";

const TabButton = ({
  children,
  handleClick,
  activeTab,
  tabValue,
  disabled = false,
  className,
  isLightMode,
  nftDeatails = false,
}) => {
  return (
    <button
      type="button"
      className={cn(
        "flex-1 rounded-lg font-medium text-sm py-2 flex items-center justify-center text-semiBlack dark:text-semiWhite",
        !nftDeatails
          ? {
              "!text-black bg-lightBlue dark:!text-white dark:bg-darkButBg border border-white dark:border-darkCardBg shadow-selectionShadow":
                activeTab === tabValue,
              "dark:text-white opacity-50 text-black": activeTab !== tabValue,
            }
          : {
              "!text-black bg-lightBlue text-white  border border-white  shadow-selectionShadow":
                activeTab === tabValue && isLightMode,
                "!text-white !bg-darkButBg border  border-darkCardBg shadow-selectionShadow":
                activeTab === tabValue && !isLightMode,
              "text-white opacity-50 ": activeTab !== tabValue  && !isLightMode,
              " opacity-50 text-black": activeTab !== tabValue  && isLightMode,
            },
        className
      )}
      onClick={() => handleClick(tabValue)}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default TabButton;
